<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">用药排班修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item1">
                                <el-form-item label="用药排班时间"  required prop="time">
                                    <el-date-picker
                                        v-model="editForm.time"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>早晨用药</span>
                                    </div>
                                    <el-tag
                                        :key="tag"
                                        v-for="tag in editForm.morningPlan"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleClose(tag)">
                                        {{tag}}
                                    </el-tag>
                                    <el-input
                                        class="input-new-tag"
                                        v-if="inputVisible"
                                        v-model="morningInputValue"
                                        ref="saveTagInput"
                                        size="small"
                                        @keyup.enter.native="handleInputConfirm"
                                        @blur="handleInputConfirm">
                                    </el-input>
                                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 药品添加</el-button>
                                </el-card>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>中午用药</span>
                                    </div>
                                    <el-tag
                                        :key="tag"
                                        v-for="tag in editForm.noonPlan"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleClose1(tag)">
                                        {{tag}}
                                    </el-tag>
                                    <el-input
                                        class="input-new-tag"
                                        v-if="inputVisible1"
                                        v-model="noonInputValue"
                                        ref="saveTagInput1"
                                        size="small"
                                        @keyup.enter.native="handleInputConfirm1"
                                        @blur="handleInputConfirm1">
                                    </el-input>
                                    <el-button v-else class="button-new-tag" size="small" @click="showInput1">+ 药品添加</el-button>
                                </el-card>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>晚上用药</span>
                                    </div>
                                    <el-tag
                                        :key="tag"
                                        v-for="tag in editForm.nightPlan"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleClose2(tag)">
                                        {{tag}}
                                    </el-tag>
                                    <el-input
                                        class="input-new-tag"
                                        v-if="inputVisible2"
                                        v-model="nightInputValue"
                                        ref="saveTagInput2"
                                        size="small"
                                        @keyup.enter.native="handleInputConfirm2"
                                        @blur="handleInputConfirm2">
                                    </el-input>
                                    <el-button v-else class="button-new-tag" size="small" @click="showInput2">+ 药品添加</el-button>
                                </el-card>
                            </el-col>
                            
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {getStaffCode} from "@/utils/auth";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: "Edit",
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    time:'',
                    scheduling:'',
                    medicationSchedulingCode:'',
                    status:'',
                    morningPlan:[],
                    noonPlan:[],
                    nightPlan:[],
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                inputVisible: false,
                inputVisible1: false,
                inputVisible2: false,
                morningInputValue: '',
                noonInputValue: '',
                nightInputValue: '',
                rules:{
                    time:[
                        { required: true, message: '请选择用药排班时间', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(row){
                this.loading=false
                this.$refs.editForm.resetFields();
                this.editForm.elderlyCode=row.elderlyCode
                this.editForm.time=row.time
                this.editForm.status=row.status
                this.editForm.medicationSchedulingCode=row.medicationSchedulingCode
                this.editForm.morningPlan=[]
                this.editForm.noonPlan=[]
                this.editForm.nightPlan=[]
                if(row.medicationSchedulingMorningDTO){
                    this.editForm.morningPlan=this.getTagName(row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList)
                }
                if(row.medicationSchedulingNoonDTO){
                    this.editForm.noonPlan=this.getTagName(row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList)
                }
                if(row.medicationSchedulingNightDTO){
                    this.editForm.nightPlan=this.getTagName(row.medicationSchedulingNightDTO.medicationSchedulingNightItemList)
                }
            },
            getTagName(value){
                var list=[]
                for(var i in value){
                    list.push(value[i].name)
                }
                return list
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            handleClose(tag) {
                this.editForm.morningPlan.splice(this.editForm.morningPlan.indexOf(tag), 1);
            },
            handleClose1(tag) {
                this.editForm.noonPlan.splice(this.editForm.noonPlan.indexOf(tag), 1);
            },
            handleClose2(tag) {
                this.editForm.nightPlan.splice(this.editForm.nightPlan.indexOf(tag), 1);
            },
            showInput() {
                this.inputVisible = true;
                this.$nextTick(value => {
                    console.log(value)
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            showInput1() {
                this.inputVisible1 = true;
                this.$nextTick(value => {
                    console.log(value)
                    this.$refs.saveTagInput1.$refs.input.focus();
                });
            },
            showInput2() {
                this.inputVisible2 = true;
                this.$nextTick(value => {
                    console.log(value)
                    this.$refs.saveTagInput2.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let morningInputValue = this.morningInputValue;
                if (morningInputValue) {
                    this.editForm.morningPlan.push(morningInputValue);
                }
                this.inputVisible = false;
                this.morningInputValue = '';
            },
            handleInputConfirm1() {
                let noonInputValue = this.noonInputValue;
                if (noonInputValue) {
                    this.editForm.noonPlan.push(noonInputValue);
                }
                this.inputVisible1 = false;
                this.noonInputValue = '';
            },
            handleInputConfirm2() {
                let nightInputValue = this.nightInputValue;
                if (nightInputValue) {
                    this.editForm.nightPlan.push(nightInputValue);
                }
                this.inputVisible2 = false;
                this.nightInputValue = '';
            },
            addSubmit(){

                this.loading = true;
                var scheduling={
                    morningPlan:this.editForm.morningPlan,
                    noonPlan:this.editForm.noonPlan,
                    nightPlan:this.editForm.nightPlan,
                }
                if((scheduling.morningPlan.length==0&&scheduling.noonPlan.length==0)&&scheduling.nightPlan.length==0){
                    this.$message.error('请填写用药信息')
                    return;
                }
                this.editForm.scheduling=scheduling
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"MedicationScheduling/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }
</script>
<style>
  .el-tag{
    margin-right: 10px;
  }
  .button-new-tag {
    height: 35px;
    line-height: 35px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 120px;
    vertical-align: bottom;
  }
</style>
<style lang="scss" scoped>
    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: scroll;
                height: 500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px 20px;
    }
    .item1{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>